var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEcosystemIcon = function SvgEcosystemIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.654 4.655A4.655 4.655 0 1 1 8.309 9.31a4.66 4.66 0 0 1-4.655-4.655Zm4.655 14.486A9.271 9.271 0 0 1 0 14.095a9.384 9.384 0 0 1 5.612-4.611 5.574 5.574 0 0 0 5.394 0 9.41 9.41 0 0 1 5.612 4.611 9.27 9.27 0 0 1-8.309 5.046Z"
  })));
};
export default SvgEcosystemIcon;